import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/educator/courses/$courseId/apps/$appId/')({
	component: Outlet,
	beforeLoad: () => {
		return redirect({
			from: '/educator/courses/$courseId/apps/$appId',
			to: './details',
		})
	},
})
